// Built once, as localeCompare with options builds a new one on every call
const tagSortOrder = new Intl.Collator('en', { sensitivity: 'base' });

// Sorts like the tag list, ignoring case and accents
export const compareTagNames = (a: string, b: string) =>
  tagSortOrder.compare(a, b);

// Ignores case only, like Ruby's downcase when the server removes a tag
export const isSameTagName = (a: string, b: string) =>
  a.toLowerCase() === b.toLowerCase();
